import React from "react"
import { createIcon } from "@chakra-ui/icons"

const CrossHairSimple = createIcon({
  displayName: "CrossHairSimple",
  viewBox: "0 0 512 512",
  path: (
    <path d="M462.6 232H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.6c-11 95.7-86.9 171.6-182.6 182.6V392c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.6C136.3 451.6 60.4 375.7 49.4 280H120c13.3 0 24-10.7 24-24s-10.7-24-24-24H49.4C60.4 136.3 136.3 60.4 232 49.4V120c0 13.3 10.7 24 24 24s24-10.7 24-24V49.4c95.7 11 171.6 86.9 182.6 182.6zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z" />
  ),
})

export default CrossHairSimple
